import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from '../../../../../../../../context/AuthHelper';
import Schema from '../../../../../../../../lib/paths/antrag_FULL_Paths.json';
import PersonalKostenAntragEmob, { getFromStrucPersonalKostenAntragEmob } from './PersonalKostenAntragEmob';

const P = Schema.attributes;

export const GetPersonalKostenAntragEmob = (application: any, hasComment?: boolean) => {
	const OrgaStruc = [
		{
			label: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, `Antragsteller`),
			content: (
				<PersonalKostenAntragEmob
					kostentraeger='Antragsteller'
					unternehmenId={get(getLocalstorageToken(), 'organisationId')}
					hasComment={hasComment}
				/>
			),
			formStruc: getFromStrucPersonalKostenAntragEmob(application, get(getLocalstorageToken(), 'organisationId')),
			showError: false,
		},
	];

	const STRUC = get(application, P.Verbundpartner.path, []).map((_ele: any, i: number) => {
		return {
			label: get(
				_ele,
				P.Verbundpartner.schema.attributes.Verbundpartner.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path.slice(
					P.Verbundpartner.path.length + 1,
				),
				`Verbundpartner ${i + 1}`,
			),
			content: <PersonalKostenAntragEmob kostentraeger='Verbundpartner' unternehmenId={get(_ele, 'Verbundpartner.id')} hasComment={hasComment} />,
			formStruc: getFromStrucPersonalKostenAntragEmob(application, get(_ele, 'Verbundpartner.id')),
			showError: false,
		};
	});
	return [...OrgaStruc, ...STRUC];
};
